/**
 * Recolor Shopify Follow on Shop (v2 loader) to Veridame door yellow.
 * Full navy knockout: Follow on + heart + Shop wordmark = #213046 on #FFB81A.
 * Strips Tailwind `text-white` so the cutout matches the footer surface.
 */
(function () {
  var SUN_YELLOW = '#FFB81A';
  var FOOTER_CHARCOAL = '#213046';
  var STYLE_ATTR = 'data-veridame-follow';

  var HOST_SELECTORS = [
    'shop-login-button',
    'shop-follow-button',
    'follow-on-shop-button'
  ];

  function paint(el, color) {
    if (!el || !el.style) return;
    el.style.setProperty('color', color, 'important');
    el.style.setProperty('-webkit-text-fill-color', color, 'important');
    el.style.setProperty('fill', color, 'important');
    el.style.setProperty('stroke', color, 'important');
  }

  function paintCharcoal(el) {
    paint(el, FOOTER_CHARCOAL);
  }

  function collectShadowRoots(root, out) {
    if (!root) return;
    var nodes = root.querySelectorAll('*');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.shadowRoot) {
        out.push(el.shadowRoot);
        collectShadowRoots(el.shadowRoot, out);
      }
    }
  }

  function findStyleTargets() {
    var roots = [];
    var seen = [];

    function addRoot(root) {
      if (!root || seen.indexOf(root) !== -1) return;
      seen.push(root);
      roots.push(root);
      collectShadowRoots(root, roots);
    }

    HOST_SELECTORS.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (host) {
        if (host.shadowRoot) addRoot(host.shadowRoot);
      });
    });

    return roots;
  }

  function isLabelSpan(span) {
    if (!span || span.tagName !== 'SPAN') return false;
    var text = (span.textContent || '').replace(/\s+/g, ' ').trim();
    return /^Follow\s+on/i.test(text);
  }

  function isHeartWrapper(el) {
    if (!el) return false;
    if (!el.classList || !el.classList.contains('px-2')) return false;
    return !!el.querySelector('svg');
  }

  function cssForRoot() {
    return (
      'button .absolute.inset-y-0,' +
      'button [class*="bg-purple"]{' +
      'background-color:' +
      SUN_YELLOW +
      '!important;}' +
      'button{' +
      'background-color:' +
      SUN_YELLOW +
      '!important;border-color:' +
      SUN_YELLOW +
      '!important;color:' +
      FOOTER_CHARCOAL +
      '!important;-webkit-text-fill-color:' +
      FOOTER_CHARCOAL +
      '!important;}' +
      'button span.cursor-pointer,' +
      'button span.whitespace-nowrap,' +
      'button span[data-veridame-follow-label],' +
      'button .px-2,' +
      'button .px-2 svg,' +
      'button .px-2 path,' +
      'button span svg,' +
      'button span path,' +
      'button svg,' +
      'button path{' +
      'color:' +
      FOOTER_CHARCOAL +
      '!important;-webkit-text-fill-color:' +
      FOOTER_CHARCOAL +
      '!important;fill:' +
      FOOTER_CHARCOAL +
      '!important;stroke:' +
      FOOTER_CHARCOAL +
      '!important;}'
    );
  }

  function ensureStyles(root) {
    if (!root || !root.querySelector) return;
    var hasUi = root.querySelector('button span, button svg, button .absolute');
    if (!hasUi) return;

    var styleEl = root.querySelector('style[' + STYLE_ATTR + ']');
    if (!styleEl) {
      styleEl = document.createElement('style');
      styleEl.setAttribute(STYLE_ATTR, 'true');
    }
    styleEl.textContent = cssForRoot();
    root.appendChild(styleEl);
  }

  function styleRoot(root) {
    ensureStyles(root);

    root.querySelectorAll('button').forEach(function (button) {
      var hasFollow =
        /Follow\s+on/i.test(button.textContent || '') ||
        button.querySelector('svg[viewBox="0 0 60 25"], svg[viewBox="0 0 20 20"]');
      if (!hasFollow) return;

      button.style.setProperty('background-color', SUN_YELLOW, 'important');
      button.style.setProperty('border-color', SUN_YELLOW, 'important');
      paintCharcoal(button);

      button.querySelectorAll('.absolute.inset-y-0, [class*="bg-purple"]').forEach(function (el) {
        el.style.setProperty('background-color', SUN_YELLOW, 'important');
        el.style.setProperty('border-color', SUN_YELLOW, 'important');
      });

      // Heart: charcoal knockout (strip Tailwind text-white).
      button.querySelectorAll('.px-2').forEach(function (wrap) {
        if (!isHeartWrapper(wrap)) return;
        wrap.classList.remove('text-white');
        paintCharcoal(wrap);
        wrap.querySelectorAll('svg, path').forEach(paintCharcoal);
      });

      // Label: charcoal Follow on + charcoal Shop wordmark.
      button.querySelectorAll('span').forEach(function (span) {
        if (!isLabelSpan(span)) return;
        span.classList.remove('text-white');
        span.setAttribute('data-veridame-follow-label', 'true');
        paintCharcoal(span);
        span.querySelectorAll('svg, path').forEach(paintCharcoal);
      });
    });
  }

  function scan() {
    findStyleTargets().forEach(styleRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  var observer = new MutationObserver(scan);
  observer.observe(document.documentElement, { childList: true, subtree: true });

  [50, 200, 500, 1000, 2000, 4000].forEach(function (ms) {
    setTimeout(scan, ms);
  });
})();
